//import { async } from "@firebase/util";
import React ,{useState,useEffect}from "react";
//import TextField from "@material-ui/core/TextField";
//import { Text } from '@react-ui-org/react-ui';
//import LazyLoad from 'react-lazyload';
//import '../../Profile.css'
import './GoldiesLoyalty.css'
import { Alert, Button, TextInput } from 'evergreen-ui'
import Thanks from "./profilethanks";
import Slider from 'react-slick';
import Modal from 'react-modal';
import {
    BrowserRouter as Router,
    Link,
    Route,
    Routes,
    useParams,
  } from "react-router-dom";
  //import { db } from "./firebase";
  import backbutton from '../pages/backbutton.png'
  import weburl from '../pages/kok.png'
  import userimg from '../pages/goldiesimage.png'
  import downpointer from '../pages/icons8-arrow-down-50.png'
  import tick from '../pages/icons8-tick-mark-26.png'
  import arrowup from '../pages/arrowup.png'
  import ReactStarRatings from 'react-star-ratings';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { Typography } from '@mui/material';
import axios from "axios";
import { calculateNewValue } from "@testing-library/user-event/dist/utils";
//import { getFirestore, collection, getDocs,firestore,updateDoc,doc,getDoc} from 'firebase/firestore';
const Blog = () => {
  const { id } = useParams();
  const [lang,countrycode,BID256,guestid] = id.split('_');
  const [businessname, setbusinessname] = useState("");
  const [membername, setmembername] = useState("");
  const [rewardname, setrewardname] = useState("");
  const [rewardlogo, setrewardlogo] = useState("");
  const [rewardlevel, setrewardlevel] = useState("");
  const [rewardpercent, setrewardpercent] = useState([]);
  const [rewardvalidity, setrewardvalidity] = useState([]);
  const [rewardclvgate, setrewardclvgate] = useState([]);
  const [memberrewardlevel, setmemberrewardlevel] = useState("");
  const [numCLV, setnumCLV] = useState("");
  const [numRewardPoints, setnumRewardPoints] = useState("");
  const [points, setPoints] = useState(0); // Current points
  const [nextLevelPoints, setNextLevelPoints] = useState(0); // Points required for the next level
  const [redeempercent , setredeempercent]=useState(0)
  const [redeemvalidity,setredeemvalidity]=useState(0)
  const progressPercentage = (points / nextLevelPoints) * 100;
  const [memberrewardlevelname, setmemberrewardlevelname] = useState("");
const [nextrewardlevelname, setnextrewardlevelname] = useState("");
  const publicurl=process.env.REACT_APP_API_JIFFYBOOKPUBLIC_URL
  const showLoader = () => {
    return (
      <div className="bouncing-ball">
        
      
      <div className="bouncing-ball">
        
        </div>
      </div>
    );
  }
 

 const fetchrewarddata = async () => {
  console.log('incountry',countrycode)
  if(countrycode=='IN'){
    const response=await fetch(`https://us-central1-jiffybook-india.cloudfunctions.net/Getrewardleveldata?parameter=${id}`)
    const result = await response.json();
    setbusinessname(result.strBname)
    setrewardname(result.strRewardsName)
    setrewardlogo(result.strRewardsLogo)
    setrewardlevel(result.numPayRewardLevels)
    setrewardpercent(result.Rewardpercent)
    setrewardvalidity(result.Rewardvalidity)
    setrewardclvgate(result.Rewardclvgate)
    setmembername(result.Cname)
    setnumCLV(result.numCLV)
    setmemberrewardlevel(result.numRewardLevel)
    setnumRewardPoints(result.numRewardPoints)
    setPoints(result.numCLV)
    //setNextLevelPoints(result.Rewardclvgate[0])
    setNextLevelPoints(result.Rewardclvgate[result.Rewardpercent.length-Number(result.numRewardLevel)])
    setredeempercent(rewardpercent[result.Rewardpercent.length-Number(result.numRewardLevel)])
    setredeemvalidity(rewardvalidity[rewardvalidity.length-Number(result.numRewardLevel)])
    setmemberrewardlevelname(result.strRewardLevelName);
setnextrewardlevelname(result.strNextRewardLevelName);
    console.log('next', nextLevelPoints,result.Rewardpercent.length,result.numRewardLevel,points,rewardclvgate[0])
  }
  if(countrycode=='EE'){
  const response=await fetch(` https://us-central1-jiffybook-app.cloudfunctions.net/Getrewardleveldata?parameter=${id}`)
  const result = await response.json();
    setbusinessname(result.strBname)
    setrewardname(result.strRewardsName)
    setrewardlogo(result.strRewardsLogo)
    //setNextLevelPoints(result.Rewardclvgate[0])
    setrewardlevel(result.numPayRewardLevels)
    setrewardpercent(result.Rewardpercent)
    setrewardvalidity(result.Rewardvalidity)
    setrewardclvgate(result.Rewardclvgate)
    setmembername(result.Cname)
    setnumCLV(result.numCLV)
    setmemberrewardlevel(result.numRewardLevel)
    setnumRewardPoints(result.numRewardPoints)
    setNextLevelPoints(result.Rewardclvgate[result.Rewardpercent.length-Number(result.numRewardLevel)])
    setPoints(result.numCLV)
    setredeempercent(rewardpercent[rewardvalidity.length-Number(result.numRewardLevel)])
    setredeemvalidity(rewardvalidity[rewardvalidity.length-Number(result.numRewardLevel)])
    setmemberrewardlevelname(result.strRewardLevelName);
setnextrewardlevelname(result.strNextRewardLevelName);
    console.log(result , redeempercent,redeemvalidity,rewardclvgate[0])
  }
  if(countrycode=='AE'){
    const response=await fetch(`https://us-central1-jiffybook-uae.cloudfunctions.net/Getrewardleveldata?parameter=${id}`)
    const result = await response.json();
    setbusinessname(result.strBname)
    setrewardname(result.strRewardsName)
    setrewardlogo(result.strRewardsLogo)
    setrewardlevel(result.numPayRewardLevels)
    setrewardpercent(result.Rewardpercent)
    setrewardvalidity(result.Rewardvalidity)
    setrewardclvgate(result.Rewardclvgate)
    setmembername(result.Cname)
    setnumCLV(result.numCLV)
    setmemberrewardlevel(result.numRewardLevel)
    setnumRewardPoints(result.numRewardPoints)
    setPoints(result.numCLV)
    //setNextLevelPoints(result.Rewardclvgate[0])
    setNextLevelPoints(result.Rewardclvgate[result.Rewardpercent.length-Number(result.numRewardLevel)])
    setredeempercent(rewardpercent[result.Rewardpercent.length-Number(result.numRewardLevel)])
    setredeemvalidity(rewardvalidity[rewardvalidity.length-Number(result.numRewardLevel)])
    setmemberrewardlevelname(result.strRewardLevelName);
setnextrewardlevelname(result.strNextRewardLevelName);
    console.log('next', nextLevelPoints,result.Rewardpercent.length,result.numRewardLevel,points,rewardclvgate[0])
  }
 }


useEffect(() => {
  fetchrewarddata();
    ;
  }, []);
  
//const agentarray=tempseg;
//tempseg.map(label=> {
  //  setCustomersData([label]);
    // })
//console.log("agent",tempseg)

let newText  = 'add \n substract'
//console.log("newtext",typeof(newText))
//console.log(imageload)
const translation = async() => {
 // const enmessage=await getDoc(doc(db,'Message','en'))
//settranslationmessage(enmessage.data().strBody)
//settranslationview(true)
};
 
    return (
        <div className="rewards-page">
          {!membername?(
            <div style={{marginLeft:"45%",marginTop:'20%'}}>
       <div className="bouncing-ball">
         {showLoader()}
         </div>
      </div>):(
        <div>
        <div className="top-section">
          <div className="content-container">
            <div className="images-container">
              {rewardlogo?(
             <img src={rewardlogo} alt="Logo 2" className="logo" />):null}
             <img src={userimg} alt="Logo 2" className="logo" />
            </div>
            <span className="rewardheader" style={{marginTop:-15}}>Membership Rewards</span>
          </div>
        </div>
        <div className="toptext">
        <span className="textstyle" style={{marginTop:-12}}>{guestid}</span>
          <span className="textstyle" style={{marginTop:7}}>Dear {membername},</span>
          <span className="textstyle">Thanks for being a valuable guest!</span>
          <p className="textstyle">
    <span>You are currently at</span>
    <p className="memberlevel">{memberrewardlevelname || `Level ${memberrewardlevel}`}</p>
  </p>
        </div>
        
        <div className="progress-container">
        <p className="progress-text1">Reached <span className="points">{points.toLocaleString()} </span>purchase values</p>
       <p className="progress-pointer" style={{
       marginLeft:`${progressPercentage - 1}%`,
       position:'relative',marginTop:-20
       }}><img src={downpointer} style={{width:12,height:12}} /></p>
        <div className="progress-bar" style={{marginTop:-20}}>
        
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <p className="progress-pointer" style={{
       textAlign:'right',
       position:'relative',marginTop:-3,marginRight:-5
       }}><img src={arrowup} style={{width:12,height:12,}} /></p>
        {(rewardlevel!=memberrewardlevel)?(
        <p className="progress-text2" style={{marginTop:-20}}>
    <span className="points">{(nextLevelPoints - points).toLocaleString()}</span> more to reach {nextrewardlevelname || `Level ${Number(memberrewardlevel) + 1}`}
  </p>):null}
      </div>
      <div className="text-container" style={{marginTop:-5}}>
          <p className="textstyle" style={{color:'#af8a50'}}><img src={tick}style={{width:12,height:12}}></img> {rewardpercent[rewardpercent.length-Number(memberrewardlevel)]}% goldies for every purchase</p>
          <p className="textstyle" style={{color:'#af8a50'}}><img src={tick}style={{width:12,height:12}}></img> Redeem goldies within {rewardvalidity[rewardvalidity.length-Number(memberrewardlevel)]} days</p>
        </div>
        </div>)}
    </div>
      );
};
  
export default Blog;